import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './CancellationPage.module.css';

const CancellationPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  // prettier-ignore
  return (
    <StaticPage
      title="Cancellation Policy"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'CancellationPage',
        description: 'Cancellation Policy',
        name: 'Cancellation page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div>
            <h1 className={css.title}>Cancellation Policy</h1>
                <p className={css.text}>Owners may create their own policies for cancellations and refunds, subject to the objection of LENDDIT and in accordance with these Terms. Any policies created by owner regarding cancellations must be clearly stated on the Equipment’s listing page. In the event that an Owner should need to cancel a rental due to circumstances outside of the reasonable control of the Owner, Owners may do so at any time prior to delivery and refund the Rental Fee back to the Renter. In the event of a cancellation, Owners should take reasonable steps to substitute the cancelled equipment with an equal or better piece of equipment. In the event of a substitution, Renters will always have the ability to reject the substitute equipment and request a refund.</p>
                <p className={css.text}>Repeatedly cancelling may result in the suspension or removal of Your account from the Platform.</p>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default CancellationPage;
